import React, { useEffect, useCallback, useState} from 'react';
import ethereum from "decentralized/ethereum.js";
import {getWorkGraphic} from 'components/explore/work/getWorkGraphic.js';
import {useInterval} from "components/hooks/useInterval.js";
import {connect} from 'react-redux';

/**
 * Gets a stream of every project ever and shows the patterns
 * morphing between theme 
 */
const StonkTicker = ({projects}) => { 
    let [graphic, setGraphic] = useState('');
    let [title, setTitle] = useState();
    let [userName, setUserName] = useState("");
    let [number, setNumber] = useState(1);

    useInterval(() => {
        setNumber(number + 1);
        setTitle(undefined);
    }, [2000]);

    useEffect(() => {
        if (!projects[number]) {
            return;
        }

        ethereum.users.getUserName(projects[number].user).then(
            setUserName);

        getWorkGraphic(projects[number], 16).then(
            ({wallpaper, graphic}) =>  {
                if (graphic) {
                    setGraphic(undefined);
                    setGraphic(graphic);
                    setTitle(projects[number].title);
                }

            }
        );
    }, [number, setGraphic, setTitle, setUserName, projects]);

    if (graphic) {
        return (
            <div
              onClick={() => window.open("/create/" + projects[number].newSequence, "_blank")}
              className="graphic">
              {graphic}
              {title ? <div className="work-title">{title} <span className="work-author">@{userName}</span></div> : ''}
            </div>);
    } else {
        return '';
    }
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StonkTicker);
